import React, { forwardRef } from "react";
import "../../style/aivrComponents.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OBCButton = forwardRef((props, ref) => {
    // extract all props to avoid passing them to the button element
    const { children, className, style, onClick, type, variant, size, disabled, icon, iconPosition, active, ...rest } = props;

    const iconSize = (buttonSize) => {
        switch (buttonSize) {
            case "sm":
                return "xs";

            case "lg":
                return "1x";

            default:
                return "sm";
        }
    };

    if (type === "file") {
        return (
            <input
                {...rest}
                ref={ref}
                type={type}
                style={style}
                onClick={onClick}
                className={`${className ? className + " " : ""}OBCButton OBCButton-${variant} OBCButton-${size}`}
                disabled={disabled}
                placeholder="test"
            />
        );
    }

    return (
        <button
            {...rest}
            ref={ref}
            style={style}
            onClick={onClick}
            className={`${className ? className + " " : ""}OBCButton OBCButton-${variant} OBCButton-${size} ${active ? "active" : ""}`}
            disabled={disabled}>
            {icon && iconPosition === "left" && (
                <FontAwesomeIcon
                    size={iconSize(size)}
                    className="OBCButton-icon"
                    icon={icon}
                />
            )}
            {children}
            {icon && iconPosition === "right" && (
                <FontAwesomeIcon
                    size={iconSize(size)}
                    className="OBCButton-icon"
                    icon={icon}
                />
            )}
        </button>
    );
});

OBCButton.defaultProps = {
    onClick: (e) => {
        e.stopPropagation();
    },
    children: "",
    type: "text",
    variant: "primary",
    size: "md",
    disabled: false,
    style: null,
    className: false,
    icon: null,
    iconPosition: "left",
    active: false,
};

export default OBCButton;
